var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHebing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.57527 4.0215V0.634399H0.5V15.3656H6.57527V11.5484",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42473 4.0215V0.634399H15.5V15.3656H9.42473V11.5484",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38171 7.62366H6.71094",
    stroke: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71282 9.53935L6.62851 7.62366L4.71282 5.70797",
    stroke: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5234 7.62363L9.19421 7.62363",
    stroke: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1923 5.70794L9.27664 7.62363L11.1923 9.53932",
    stroke: "#00C2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHebing);
export default __webpack_public_path__ + "static/media/hebing.ed149cf9b6cdb267661e3b588f503778.svg";
export { ForwardRef as ReactComponent };